import React from 'react';

const ChallengeTypeVideo = () => {
    return <></>;
};

export default ChallengeTypeVideo;
